import { Col, Container, Row, Stack } from 'react-bootstrap'
import React from 'react'
import { MeetingProviderAccountIntegrationConfig } from '../../../../../models/Account'
import { useAppSelector } from '../../../../../store/hooks'
import './PhoneControls.scss'
import { selectRoomSession } from '../../../../../store/meetingSummary/roomSession'
import { StartPhoneButtons } from './StartPhoneButtons'

export interface PhoneControlsProps {
  hasPhoneIntegration: boolean
  phoneConfig: MeetingProviderAccountIntegrationConfig | null
}

export const PhoneControls: React.FC<PhoneControlsProps> = ({ hasPhoneIntegration, phoneConfig }) => {
  const session = useAppSelector(selectRoomSession)

  if (!phoneConfig?.sharedPhoneLineEnabled && !hasPhoneIntegration) {
    return null
  }

  const StartSharedLineCall = () => (
    <Stack gap={3}>
      <div className='paragraph-small'>
        To use shared phone lines, select from the options below. You'll get setup instructions to connect the AI Assistant to your call.
      </div>
      <StartPhoneButtons session={session} phoneConfig={phoneConfig} />
      {hasPhoneIntegration && (
        <div className='paragraph-small'>
          <span className='medium'>Or use your linked phone number</span> - just start a call, and Zocks will find your matching meeting.
        </div>
      )}
    </Stack>
  )

  const StartLinkedLineCall = () => (
    <Stack gap={2}>
      <ol>
        <li>Start a call from your linked phone number</li>
        <li>Zocks will automatically search for a matching meeting</li>
        <li>Confirm the match when prompted</li>
      </ol>
    </Stack>
  )

  return (
    <Container className='d-flex flex-column align-items-start gap-3 p-3 border rounded-3 zocks-border-color-gray-300 zocks-bg-color-gray-100'>
      <Row>
        <Col>
          <h5>How to start a Phone Meeting</h5>
        </Col>
      </Row>
      <Row>
        <Col>{phoneConfig?.sharedPhoneLineEnabled ? <StartSharedLineCall /> : <StartLinkedLineCall />}</Col>
      </Row>
    </Container>
  )
}
